import React from "react"
import PropTypes from "prop-types"

class ConnectPreview extends React.Component {
  constructor(props) {
    super(props)


    this.state = {
      accountCancelled: false
    }

    this.cancelAccount = this.cancelAccount.bind(this)
  }

  cancelAccount() {
    this.setState({
      accountCancelled: true
    })
    $.ajax({
      url: `../cancel_user/${this.props.connect.requestor_id}`,
      dataType: 'JSON',
      type: 'GET',
      header: {
        'Content-Type': 'application/json'
      },
      success: () => {
        console.log('success')
      },
      error: function(xhr, status, err) {
        console.log(err)
      }.bind(this)
    });
  }

  render() {
    return(
      <div className="admin_user_preview table_row" style={{display: 'flex', justifyContent: 'space-around'}}>
        <button onClick={() => window.open(`/profile/${this.props.user.slug}`)}>
        </button>
        <div style={{width: '65%'}}>
          <p>{this.props.connect.msg}</p>
        </div>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>
          <button style={{textAlign: 'center', marginBottom: 10}} className="small_button_secondary" onClick={() => window.open(`../profile/${this.props.connect.requestor_id}`)}>See Requestor Profile</button>
          {this.state.accountCancelled === true ? <p style={{textAlign: 'center'}} className="darkBlue">Account Cancelled</p>:<button className={"small_button_primary"} onClick={() => this.cancelAccount()}>Cancel Account</button>}
        </div>

      </div>
    )
  }
}


export default ConnectPreview;
